<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="card shadow">
        <div class="card-header bg-danger text-white">
          <h3 class="card-title text-center">Terms and Conditions</h3>
        </div>
        <div class="card-body">
          <!-- Introduction Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">1. Introduction</h4>
            <p>
              Welcome to <strong>SmartDukaan</strong> (a service operated by <strong>New Spice Solutions Pvt Ltd</strong>, hereafter referred to as "SmartDukaan," "NSSPL," "we," "us," or "our"). Our registered office is located at <strong>S1-120, B-35, UTC Business Tower, Sector 132, Noida-201301, UP, India</strong>, and our corporate address is <strong>Priska Tower, 2nd Floor, C-56/45, C Block, Industrial Area Phase 2, Sector 62, Noida - 201309 (UP)</strong>.
            </p>
            <p>
              By accessing or using our website (<strong>www.smartdukaan.com</strong>), you agree to be bound by these Terms and Conditions. These terms apply indefinitely, and you are bound by them as long as you use this website. We reserve the right to modify these terms at any time without prior notice.
            </p>
          </section>

          <!-- Use of the Website Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">2. Use of the Website</h4>
            <p>
              You agree to use the website only for lawful purposes and in accordance with these terms. Unauthorized use (including copying, reproducing, or storing content without permission) may result in legal action.
            </p>
          </section>

          <!-- Products and Services Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">3. Products and Services</h4>
            <p>
              We sell mobile phones and related electronics. Product descriptions, pricing, and availability are subject to change without notice. While we strive for accuracy, we do not guarantee that all information is error-free.
            </p>
          </section>

          <!-- User Account Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">4. User Account</h4>
            <p>
              To access certain services, you may need to create an account. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.
            </p>
          </section>

          <!-- Orders and Payments Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">5. Orders and Payments</h4>
            <ul>
              <li>Orders are subject to product availability and our acceptance.</li>
              <li>Payment must be made via approved gateways.</li>
              <li>We reserve the right to cancel or refuse any order at our discretion.</li>
            </ul>
          </section>

          <!-- Shipping and Returns Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">6. Shipping and Returns</h4>
            <ul>
              <li>Delivery timelines will be provided during checkout.</li>
              <li>Returns are accepted as per our <strong>Return Policy</strong> (available on our website).</li>
              <li><strong>Only unused and boxed products</strong> are eligible for exchange in case of incorrect delivery.</li>
              <li>Return shipping and restocking fees may apply.</li>
            </ul>
          </section>

          <!-- Warranties and Liability Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">7. Warranties and Liability</h4>
            <ul>
              <li>Products may come with manufacturer warranties.</li>
              <li>We are not liable for any <strong>indirect, incidental, or consequential damages</strong> arising from product use or website access.</li>
            </ul>
          </section>

          <!-- Intellectual Property Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">8. Intellectual Property</h4>
            <p>
              All content (logos, text, images, software) is owned by <strong>New Spice Solutions Pvt Ltd</strong> or its licensors and is protected under copyright and intellectual property laws.
            </p>
          </section>

          <!-- User Conduct Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">9. User Conduct</h4>
            <p>
              You agree <strong>not</strong> to:
            </p>
            <ul>
              <li>Use the website for fraudulent purposes.</li>
              <li>Post unlawful, harmful, or obscene content.</li>
            </ul>
            <p>
              Violations may result in account suspension or termination.
            </p>
          </section>

          <!-- Third-Party Links Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">10. Third-Party Links</h4>
            <p>
              This website may include links to third-party sites. These are provided for convenience only, and we do not endorse or assume responsibility for their content.
            </p>
          </section>

          <!-- Privacy Policy Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">11. Privacy Policy</h4>
            <p>
              Your use of the website is also governed by our <strong>Privacy Policy</strong>, which outlines how we collect, use, and protect your data.
            </p>
          </section>

          <!-- Modifications Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">12. Modifications</h4>
            <p>
              We may update these Terms at any time. Changes will be posted here with a revised effective date. Continued use of the website constitutes acceptance of the updated Terms.
            </p>
          </section>

          <!-- Governing Law Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">13. Governing Law & Jurisdiction</h4>
            <p>
              These Terms are governed by Indian law. Any disputes shall be subject to the <strong>exclusive jurisdiction of courts in Noida, India</strong>.
            </p>
          </section>

          <!-- Contact Information Section -->
          <section class="mb-5">
            <h4 class="text-danger mb-4">Contact Information</h4>
            <p>
              For queries, complaints, or suggestions:
            </p>
            <ul>
              <li>

                <strong>Email:</strong>{{'care@smartdukaan.com'}}
              </li>
              <li>
                <strong>Phone:</strong> <a href="tel:18002700273">1800-2700-273</a> (10:00 AM – 7:00 PM IST)
              </li>
              <li>
                <strong>Address:</strong> Priska Tower, 2nd Floor, C-56/45, C Block, Industrial Area Phase 2, Sector 62, Noida - 201309 (UP)
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
</div>
